import { render, staticRenderFns } from "./ResourceEditFormChild.vue?vue&type=template&id=6c826eb9&"
import script from "./ResourceEditFormChild.vue?vue&type=script&lang=js&"
export * from "./ResourceEditFormChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports